export const VENUE_TYPES = ['winery', 'tasting room', 'wine bar', 'restaurant', 'other'] as const;
export const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export type VenueType = (typeof VENUE_TYPES)[number];

export interface OperatingHours {
  [key: string]: {
    open: string;
    close: string;
    closed?: boolean;
  };
}

// A factory, not a shared constant, so each mount gets its own object.
export const createDefaultOperatingHours = (): OperatingHours => ({
  monday: { open: '10:00', close: '17:00' },
  tuesday: { open: '10:00', close: '17:00' },
  wednesday: { open: '10:00', close: '17:00' },
  thursday: { open: '10:00', close: '17:00' },
  friday: { open: '10:00', close: '17:00' },
  saturday: { open: '10:00', close: '17:00' },
  sunday: { open: '10:00', close: '17:00' },
});
